import { useEffect, useState } from "react";
import PropertyItem from "../PropertyItem";
import { PROPERTIES_URL } from "../../Global/API's";
import LoadingView from "../Loader";

function getBoundingBox(lat, lng, radiusInKm) {
  const earthRadius = 6371;

  const deltaLat = radiusInKm / earthRadius;
  const deltaLng = radiusInKm / (earthRadius * Math.cos((Math.PI * lat) / 180));

  const minLat = lat - deltaLat * (180 / Math.PI);
  const maxLat = lat + deltaLat * (180 / Math.PI);
  const minLon = lng - deltaLng * (180 / Math.PI);
  const maxLon = lng + deltaLng * (180 / Math.PI);

  return { minLat, maxLat, minLon, maxLon };
}

const NearbyLisintgs = (props) => {
  const { latitude, longitude, listingID } = props.obj;
  const [properties, setProperties] = useState([]);

  const MIN_RESULTS = 5;
  const MAX_RADIUS = 30;
  const INITIAL_RADIUS = 5;
  const STEP_RADIUS = 5;

  useEffect(() => {
    let currentRadius = INITIAL_RADIUS;
    async function fetchUntilEnoughProperties() {
      while (currentRadius <= MAX_RADIUS) {
        const { minLat, maxLat, minLon, maxLon } = getBoundingBox(
          latitude,
          longitude,
          currentRadius
        );

        const query = new URLSearchParams({
          minLat: minLat.toString(),
          maxLat: maxLat.toString(),
          minLon: minLon.toString(),
          maxLon: maxLon.toString(),
          limit: 5,
        });

        try {
          const response = await fetch(`${PROPERTIES_URL}?${query}`);
          if (!response.ok) throw new Error("Fetch failed");
          const data = await response.json();
          if (
            data.data.length === MIN_RESULTS ||
            currentRadius === MAX_RADIUS
          ) {
            setProperties(data);
            break;
          } else {
            currentRadius += STEP_RADIUS;
          }
        } catch (err) {
          console.error("Error fetching properties:", err);
          break;
        }
      }
    }

    fetchUntilEnoughProperties();
  }, [latitude, longitude]);

  const renderProperties = () => {
    const fetchedProperties = properties.data.filter(
      (item) => item.property.listingID !== listingID
    );
    return (
      <ul className="properties-list-items">
        {fetchedProperties.slice(0, 4).map((item) => (
          <PropertyItem key={item.property.listingID} eachProperty={item} />
        ))}
      </ul>
    );
  };

  return (
    <div className="featured-areas">
      <div className="container-fluid">
        <h2>
          <strong>Nearby</strong> Listings
        </h2>
        {properties.status === "Success" ? renderProperties() : <LoadingView />}
      </div>
    </div>
  );
};

export default NearbyLisintgs;
